import { ExpandMore } from '@mui/icons-material';
import { Checkbox } from '@mui/material';
import { FormControlLabel, Grid } from '@mui/material';
import { Accordion, AccordionDetails, Paper, Typography } from '@mui/material';
import { CertificationFormVM } from 'front-office/view-models/document-birth-form';
import { useFormikContext } from 'formik';
import { memo, useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import CertificationForm from './form';

const AccordionCertificationComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<CertificationFormVM>();

  const { userProfile } = useUserProfile();

  const cashManagement = userProfile?.datiLogin?.profile?.servizio?.gestioneCassa || '';

  const isDisabled = cashManagement !== 'S';

  return (
    <>
      <Paper elevation={3} className="pmi-px-3 pmi-pb-2">
        <Grid
          item
          xs={12}
          container
          spacing={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  id="flagInternal"
                  checked={formContext.values.flagInternal || false}
                  disabled={isDisabled}
                  onChange={() => {
                    formContext.setValues({
                      ...formContext.values,
                      flagCarta: !formContext.values.flagInternal,
                      flagInternal: !formContext.values.flagInternal,
                    });
                    setOpen(!formContext.values.flagInternal);
                  }}
                  inputProps={{ 'aria-label': 'uso interno' }}
                />
              }
              label="Uso interno"
            />
          </Grid>
        </Grid>
      </Paper>
      {formContext.values.flagInternal ? (
        <Grid item xs={12}>
          <PmiTextField
            aria-label="Motivo"
            label="Motivo"
            id="reason"
            name="reason"
            fullWidth
            type="text"
            variant="outlined"
            multiline
            rows={3}
            error={formContext.touched?.reasonRelease && Boolean(formContext.errors?.reasonRelease)}
            helperText={formContext.errors?.reasonRelease}
            value={formContext.values.reasonRelease || ''}
            onChange={(event) => formContext.setFieldValue('reasonRelease', event?.target.value)}
          />
        </Grid>
      ) : (
        <Accordion
          expanded={open}
          onChange={() => {
            setOpen(!open);
          }}
        >
          <AccordionSummary
            aria-controls={`panel-register-office-Generalità intestatario-content`}
            id={`panel-register-office-Generalità intestatario-header`}
            expandIcon={<ExpandMore />}
          >
            <Typography>Richiedente</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <CertificationForm />
          </AccordionDetails>
        </Accordion>
      )}

      <div className="pmi-pt-3 pmi-d-flex pmi-justify-content-center">
        <div className="pmi-pl-2 pmi-w-25 pmi-w-lg-15">
          <PmiButton variant="outlined" fullWidth color="secondary" type="submit">
            Avanti
          </PmiButton>
        </div>
      </div>
    </>
  );
};

AccordionCertificationComponent.displayName = 'Accordion Certification component';

const AccordionCertification = memo(AccordionCertificationComponent);

export default AccordionCertification;
